import React, { useState, useEffect, useRef } from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import loginBg from '../assets/login_bg.png';
import Login from '../components/Login';
import Register from '../components/Register';
import ForgotPassword from '../components/ForgotPassword';
import { authAPI } from '../api/api';
import '../css/Login.css';

const AuthPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showRegister, setShowRegister] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [animating, setAnimating] = useState(false);
  const animTimeout = useRef();


  useEffect(() => {
    const currentUser = authAPI.getCurrentUser();
    if (currentUser) {

      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('register')) {
      setShowRegister(true);
      setIsFlipped(true);
    } else {
      setShowRegister(false);
      setIsFlipped(false);
    }
  }, [location.search]);

  const handleFlip = () => {
    setAnimating(true);
    setTimeout(() => {
      setIsFlipped(f => !f);
      setTimeout(() => setAnimating(false), 400);
    }, 60);
  };

  useEffect(() => () => clearTimeout(animTimeout.current), []);

  return (
    <div className="login-container">
      <div className={`login-split-bg${isFlipped ? ' flipped' : ''}${animating ? ' animating' : ''}`}> 
        <div className="login-panel login-panel-image">
          <img src={loginBg} alt="Login" />
          <div className="login-panel-caption">
            <h3>Üdvözlünk!</h3>
            <p>Jelentkezz be, hogy elérd a fiókodat.</p>
          </div>
        </div>
        <div className="login-panel login-panel-form">
          {showForgotPassword ? (
            <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />
          ) : showRegister ? (
            <Register onSwitchToLogin={() => setShowRegister(false)} />
          ) : (
            <Login
              onForgotPassword={() => setShowForgotPassword(true)}
              onSwitchToRegister={() => setShowRegister(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage; 